import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    padding: '2em',
    backgroundColor: theme.palette.grey[200],
    width: '100%'
  },
  paper: {
    padding: '1em',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)'
  },
  loading: { height: '100vh' },
  editButton: {
    backgroundColor: theme.palette.warning.main,
    color: 'white',
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
    [theme.breakpoints.down('xs')]: {
      '&.MuiButton-root': {
        maxWidth: 32,
        minWidth: 0
      }
    }
  },
  deleteButton: {
    backgroundColor: theme.palette.error.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
    [theme.breakpoints.down('xs')]: {
      '&.MuiButton-root': {
        maxWidth: 32,
        minWidth: 0
      }
    }
  },
  notset: {
    color: theme.palette.text.secondary
  },
  filterButton: {
    color: 'white',
    backgroundColor: theme.palette.info.main,
    '&:hover': {
      backgroundColor: theme.palette.info.dark,
    }
  },
  resetButton: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.dark,
    }
  },
  filterForm: {
    width: 'auto'
  },
  addIcon: {
    color: theme.palette.success.main,
  },
  checkboxInput: {
    '&.Mui-checked': {
      color: theme.palette.success.main
    }
  },
  buttonIcon: {
    color: 'white',
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.dark
    }
  },
  dataGrid: {
    marginTop: theme.spacing(3),
  },
  link: {
    color: theme.palette.info.main,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.info.light
    }
  }
}))